import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';

export const Container = styled.div``;

export const Content = styled.div`
  width: 340px;
  max-height: 170px;
  border: 1px solid black;
  background-color: #fffaf0;
  padding: 5px 10px;

  div {
    margin: 4px 0px;
    display: flex;
    flex-direction: row;
  }
`;

export const Label = withStyles({
  root: {
    fontWeight: 500,
    fontSize: 12,
    whiteSpace: 'pre',
  },
})(Typography);

export const Value = withStyles({
  root: {
    textDecoration: 'underline',
    fontSize: 12,
    marginRight: 7,
    marginLeft: 7,
  },
})(Typography);
